// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// const AuthProvider = ({ children }) => {
//   // const navigate = useNavigate();
//   // const [isAuthenticated, setIsAuthenticated] = useState(false);

//   // useEffect(() => {
//   //   const adminInfo = localStorage.getItem('adminInfo');
//   //   if (adminInfo) {
//   //     setIsAuthenticated(true);
//   //   }
//   // }, []);

//   // useEffect(() => {
//   //   if (isAuthenticated) {
//   //     navigate('/dashboard');
//   //   } else {
//   //     // navigate('/login');
//   //     return
//   //   }
//   // }, [isAuthenticated, navigate]);

//   return (
//     <React.Fragment>
//       {children}
//     </React.Fragment>
//   )
// }

// export default AuthProvider

import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null); // 'admin', 'supplier', 'user'

  useEffect(() => {
    // Check if user is logged in on app start
    const adminData = localStorage.getItem('adminData');
    const supplierData = localStorage.getItem('supplierData');
    const supplierLoggedIn = localStorage.getItem('supplierLoggedIn');
    
    if (adminData) {
      try {
        const parsedAdmin = JSON.parse(adminData);
        setUser(parsedAdmin);
        setUserRole('admin');
      } catch (error) {
        console.error('Error parsing admin data:', error);
        logout();
      }
    } else if (supplierLoggedIn && supplierData) {
      try {
        const parsedSupplier = JSON.parse(supplierData);
        setUser(parsedSupplier);
        setUserRole('supplier');
      } catch (error) {
        console.error('Error parsing supplier data:', error);
        logout();
      }
    } else {
      setUserRole('user');
    }
    setLoading(false);
  }, []);

  const adminLogin = (adminData) => {
    localStorage.setItem('adminData', JSON.stringify(adminData));
    setUser(adminData);
    setUserRole('admin');
  };

  const supplierLogin = (supplierData) => {
    localStorage.setItem('supplierLoggedIn', 'true');
    localStorage.setItem('supplierData', JSON.stringify(supplierData));
    setUser(supplierData);
    setUserRole('supplier');
  };

  const logout = () => {
    localStorage.removeItem('adminData');
    localStorage.removeItem('supplierLoggedIn');
    localStorage.removeItem('supplierData');
    setUser(null);
    setUserRole('user');
  };

  const value = {
    user,
    userRole,
    adminLogin,
    supplierLogin,
    logout,
    isAuthenticated: !!user,
    isAdmin: userRole === 'admin',
    isSupplier: userRole === 'supplier',
    isUser: userRole === 'user',
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;